import { TextBlock } from '../../Atoms/Text';

export const FileNumberRenderer = ({ fileNumber }: { fileNumber: number }) => {
  return (
    <div className="p-2 rounded bg-card-1 flex justify-center align-middle items-center w-[20px] h-[20px]">
      <TextBlock
        size="sm"
        weight="normal"
        color="grey5">
        {fileNumber === 0 ? '—' : fileNumber}
      </TextBlock>
    </div>
  );
};
